export enum PaginationSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface PaginationQueryDto {
  page?: number;
  limit?: number;
  sortBy?: Record<string, number>;
  order?: PaginationSortOrder;
  filter?: Record<string, unknown>;
}

export interface PaginationDto<T> {
  items: T[];
  total: number;
  totalPages: number;
  page: number;
  limit: number;
}
